import { Box, Fade } from '@mui/material'
import ProjectsList from './ProjectsList/ProjectsList'

const Projects = () => {
  return (
    <Fade in={true} timeout={1000}>
      <Box
        height={'100%'}
        width={'90%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
      >
        <ProjectsList
          data={[
            {
              id: 0,
              title: 'DevFinances',
              description: 'A personal web finances app, build with HTML, CSS, and JS.',
              image: 'fsa',
              address: 'https://christian-ricarte.github.io/r-devfinances/',
              repository: 'https://github.com/christian-ricarte/r-devfinances'
            },
          ]}
        />
      </Box>
    </Fade>
  )
}

export default Projects
